var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "description",
            label: _vm._f("pgettext")("Description", "ExchangeRateDateRule"),
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "description" },
            model: {
              value: _vm.item.description,
              callback: function($$v) {
                _vm.$set(_vm.item, "description", $$v)
              },
              expression: "item.description"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            name: "reference_month",
            label: _vm._f("pgettext")(
              "Reference month",
              "ExchangeRateDateRule"
            ),
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormSelect", {
            attrs: {
              name: "reference_month",
              options: _vm.referenceMonthOptions,
              valueField: "value",
              textField: "name",
              required: ""
            },
            model: {
              value: _vm.item.reference_month,
              callback: function($$v) {
                _vm.$set(_vm.item, "reference_month", $$v)
              },
              expression: "item.reference_month"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: _vm.labelColsMd,
            contentColsMd: _vm.contentColsMd,
            name: "day_specifier",
            label: _vm._f("pgettext")("Day specifier", "ExchangeRateDateRule"),
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormSelect", {
            attrs: {
              name: "day_specifier",
              options: _vm.daySpecifierOptions,
              valueField: "value",
              textField: "name",
              required: ""
            },
            model: {
              value: _vm.item.day_specifier,
              callback: function($$v) {
                _vm.$set(_vm.item, "day_specifier", $$v)
              },
              expression: "item.day_specifier"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: _vm.labelColsMd,
            contentColsMd: _vm.contentColsMd,
            name: "day_value",
            label: _vm._f("pgettext")("Day value", "ExchangeRateDateRule"),
            labelAlign: _vm.labelAlign,
            contentClass: "input-group"
          }
        },
        [
          _c("ItpFormInput", {
            ref: "offsetDays",
            attrs: { type: "number", name: "day_value" },
            model: {
              value: _vm.item.day_value,
              callback: function($$v) {
                _vm.$set(_vm.item, "day_value", $$v)
              },
              expression: "item.day_value"
            }
          }),
          _vm._v(" "),
          _c("DIV", { staticClass: "input-group-append" }, [
            _c("span", { staticClass: "input-group-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("pgettext")("day", "InputGroupAddon")) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }